function page(path) {
  return () => import(/* webpackChunkName: '' */ `@/pages/${path}`).then(m => m.default || m);
}

export default [
  {
    path: '/login',
    name: 'app.auth.login',
    component: page('auth/Login.vue')
  },
  {
    path: '/register',
    name: 'app.auth.register',
    component: page('auth/Register.vue')
  },
  {
    path: '/password/reset',
    name: 'app.auth.password.request',
    component: page('auth/PasswordRequest.vue')
  },
  {
    path: '/password/reset/:token',
    name: 'app.auth.password.reset',
    component: page('auth/PasswordReset.vue')
  },
  {
    path: '/password/set/:user/:hash',
    name: 'app.auth.password.set',
    component: page('auth/PasswordSet.vue')
  },
  {
    path: '/',
    name: 'app.dashboard.index',
    component: page('dashboard/Index.vue')
  },
  {
    path: '/experiments/:id',
    name: 'app.experiments.show',
    component: page('experiments/Index.vue')
  },
  {
    path: '/virtual-microscope',
    name: 'app.current_experiment',
    component: page('experiments/Index.vue')
  },
  {
    path: '/experiments/:id/register',
    name: 'app.experiments.register',
    component: page('experiments/RegisterForm.vue')
  },
  {
    path: '/experiments/:id/guardian-consent/:user',
    name: 'app.experiments.guardian_consent',
    component: page('experiments/GuardianConsentForm.vue'),
    meta: {
      disable_navbar: true
    }
  },
  {
    path: '/experiments/:id/contents/:content',
    name: 'app.experiments.contents',
    component: page('pages/Index.vue')
  },
  {
    path: '/pages/:content',
    name: 'app.pages',
    component: page('pages/Index.vue'),
  },
  {
    path: '/get-started',
    name: 'app.get_started',
    component: page('pages/GetStarted.vue'),
  },
  {
    path: '/my-profile',
    name: 'app.edit_my_profile',
    component: page('profile/Edit.vue')
  },
  {
    path: '/errors/403',
    name: 'errors.403',
    component: page('errors/403.vue')
  },
  {
    path: '/errors/link-expired',
    name: 'errors.link_expired',
    component: page('errors/LinkExpired.vue')
  },
  {
    path: '*',
    name: 'errors.404',
    component: page('errors/404.vue')
  }
];
